import { Location, navigate, Router } from '@reach/router';
//import AuthenticationHandler, { AuthenticationHandlerRenderProps } from '@virtus/common/auth/AuthenticationHandler';
import { logout } from '@virtus/common/auth/msalWrapper';
import AuthenticationHandlerAdmin, { AuthenticationHandlerRenderProps } from './AuthenticationHandlerAdmin';
import { authSelectors } from '@virtus/common/auth/reducer';
import { VirtusTheme } from '@virtus/components';
import { LoadingIconSizes, LoadingIconType } from '@virtus/components/LoadingIcon/LoadingIcon';
import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import { mutateAsync, querySelectors } from 'redux-query/advanced';
import UseSignalR, { useSignalR } from 'src/comps/SignalR/UseSignalR';
import AdminUserProfile, { ReduxProps as AdminUserProfileProps } from 'src/comps/UserProfile/UserProfile';
import config from 'src/config';
import configureHeader from 'src/config/headerConfig';
import DropDownControlCodeTableRow from 'src/formcontrols/DropDown/DropDownControlCodeTableRow';
import CheckBoxControlRow from 'src/formcontrols/CheckBoxControl/CheckBoxControlRow';
import Loading from 'src/formcontrols/Loading';
import { EditModal } from 'src/formcontrols/Modals/EditModal/EditModal';
import { appResponseSelector, getUserProfile, saveUserProfile } from 'src/queries/userProfile';
import { dateRangeSelectorActions } from 'src/reducers/dateRangeSelector';
import { inspectorActions } from 'src/reducers/inspector';
import { RootState } from 'src/reducers/rootReducer';
import { routes } from 'src/routes';
import WidgetContainer from 'src/WidgetContainer/WidgetContainer';
import styled from 'styled-components';
import { GetLocalStateProfile } from 'src/comps/UserProfile/UserProfile';
import { writeAIEvent } from 'src/utils/AppInsight';
import SignalRConnector from 'src/coreservices/SignalRConnector';
//import { getUser } from '@virtus/common/auth/msalWrapper';
import { getUser, logoutAad } from '@virtus/common/auth/aadWrapper';

const NotFound = React.lazy(() => import('@virtus/components/page/NotFound'));
const Header = React.lazy(() => import('@virtus/components/page/Header'));
const DetailsLogInspector = React.lazy(() => import('src/comps/Inspector/DetailsLogInspector'));
const Home = React.lazy(() => import('src/pages/Home'));
const Logs = React.lazy(() => import('src/pages/Logs'));
const Tools = React.lazy(() => import('src/pages/Tools'));
const EventLog = React.lazy(() => import('src/pages/EventLog'));
const ErrorLog = React.lazy(() => import('src/pages/ErrorLog'));
const SignalRLog = React.lazy(() => import('src/pages/SignalRLog'));
const UserLog = React.lazy(() => import('src/pages/UserLog'));
const AddError = React.lazy(() => import('src/pages/AddError'));
const Application = React.lazy(() => import('src/pages/ApplicationDetails'));
const ApplicationInsight = React.lazy(() => import('src/pages/AppInsightDetails'));
const DevOpsOutput = React.lazy(() => import('src/pages/DevOpsOutput'));
const UserLogPage = React.lazy(() => import('src/pages/UserLogPage'));

const headerConfiguration = configureHeader(routes);

interface IState {
  openUserProfile: boolean;
  numberOfGridRows: INumberOfGridRow[];
  numberOfGridRow: string;
  defaultSearchTimeSpans: IDefaultSearchTimeSpan[];
  defaultSearchTimeSpan: string;
  defaultUseSignalR: boolean;
  isLoading: boolean;
  isOpenSignalRDetail: boolean;
  onSaveUseSignalR: boolean;
}
interface INumberOfGridRow {
  numberOfGridRow: number;
}
interface IDefaultSearchTimeSpan {
  defaultSearchTimeSpan: string;
  defaultSearchTimeSpanValue: string;
}

interface ReduxProps {
  readonly authStatus: any;
  readonly authError: any;
  isLoading: boolean;
  response: string;
  //  id_token?: string;
}

interface ReduxDispatch {
  closeInspectors: () => void;
  clearDateRanges: () => void;
  closeTimeFrame: () => void;
  saveUserProfile: any;
  getUserProfile: any;
}
interface IProps {
  isOpenPopup: boolean;
  userName: string;
  saveUserProfile: (userName: string, numberOfGridRow: number, defaultSearchTimeSpan: string, defaultUseSignalR: boolean) => void;
  getUserProfile: (userName: string) => void;
}
type Props = IProps & ReduxProps & ReduxDispatch;
/** Theme, Header and Routing */

const logoutUser = () => {
  //logout();
  logoutAad();
};

class App extends React.Component<Props, IState> {
  public static stNumberOfGridRow: string;
  public static stDefaultSearchTimeSpan: string;
  public static stUserName: string;
  public static stDefaultUseSignalR: boolean;
  public static getDetails() {
    return {
      numberOfGridRow: App.stNumberOfGridRow,
      defaultSearchTimeSpan: App.stDefaultSearchTimeSpan,
      userName: App.stUserName,
      defaultUseSignalR: App.stDefaultUseSignalR
    };
  }
  public userObj: any;
  // public config: any;
  constructor(props: any) {
    super(props);
    this.state = {
      openUserProfile: this.props.isOpenPopup,
      numberOfGridRows: [
        { numberOfGridRow: 10 },
        { numberOfGridRow: 25 },
        { numberOfGridRow: 50 },
        { numberOfGridRow: 100 },
        { numberOfGridRow: 200 },
      ],
      numberOfGridRow: config.defaultProfile.DefaultGridRows.toString(),
      defaultSearchTimeSpans: [
        { defaultSearchTimeSpanValue: 'P30M', defaultSearchTimeSpan: 'Past 30 Minutes' },
        { defaultSearchTimeSpanValue: 'P1H', defaultSearchTimeSpan: 'Past Hour' },
        { defaultSearchTimeSpanValue: 'P4H', defaultSearchTimeSpan: 'Past 4 Hours' },
        { defaultSearchTimeSpanValue: 'P6H', defaultSearchTimeSpan: 'Past 6 Hours' },
        { defaultSearchTimeSpanValue: 'P12H', defaultSearchTimeSpan: 'Past 12 Hours' },
        { defaultSearchTimeSpanValue: 'P24H', defaultSearchTimeSpan: 'Past 24 Hours' },
        { defaultSearchTimeSpanValue: 'P3D', defaultSearchTimeSpan: 'Past 3 Days' },
        { defaultSearchTimeSpanValue: 'P7D', defaultSearchTimeSpan: 'Past 7 Days' },
        { defaultSearchTimeSpanValue: 'P30D', defaultSearchTimeSpan: 'Past 30 Days' },
      ],
      defaultSearchTimeSpan: config.defaultProfile.DefaultTimeRange,
      isLoading: false,
      defaultUseSignalR: config.defaultProfile.DefaultUseSignalR,
      isOpenSignalRDetail: false,
      onSaveUseSignalR: false,
    };
    this.updateUseSignalR = this.updateUseSignalR.bind(this);
  }

  async componentDidMount() {
    // let result = "useIDP" in config;
    // if(result && config.useIDP) {
    //   return;
    // } else {
    await this.props.getUserProfile(getUser());
    await this.connectSignalR();
  }
  //}

  async connectSignalR() {
    const userProfile = GetLocalStateProfile();
    if (userProfile.DefaultUseSignalR) {
      const signalRConnector = new SignalRConnector({ isUseSignalR: false });
      await signalRConnector.connectToSignalR();
      signalRConnector.updateUseSignalR(true);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'block';
      }
    }
  }

  trackAiEvent = (path: string | undefined) => {
    let pageName = path;
    do {
      pageName = pageName.replace('/', '');
    } while (pageName.indexOf('/') > -1);
    writeAIEvent(`Transited to page - ${pageName}`);
  };

  logoutFromApp = () => {
    writeAIEvent(`${this.props.userName} logged out from Virtus Admin Application.`);
  };

  onRouteChange = (path?: string) => {
    this.setState({ openUserProfile: false, isOpenSignalRDetail: false });
    this.props.closeInspectors();
    this.props.clearDateRanges();
    this.props.closeTimeFrame();

    this.trackAiEvent(path);

    navigate(`${path}`);
  };

  async openUserProfilePopup() {
    await this.setState({ openUserProfile: true });
    const userProfileDetails = GetLocalStateProfile();
    writeAIEvent(`Opened User profile modal window.`);
    await this.setState({
      numberOfGridRow: userProfileDetails.DefaultGridRows,
      defaultSearchTimeSpan: userProfileDetails.DefaultTimeRange,
      defaultUseSignalR: userProfileDetails.DefaultUseSignalR,
    });
  }

  saveToStorage = (userProfile: any) => {
    if (userProfile !== undefined)
      localStorage.setItem('USER_PROFILE_LOCAL', JSON.stringify(userProfile))
  }

  saveUserProfile = async () => {
    App.stDefaultSearchTimeSpan = this.state.defaultSearchTimeSpan;
    App.stNumberOfGridRow = this.state.numberOfGridRow;
    App.stUserName = this.props.userName;
    App.stDefaultUseSignalR = this.state.defaultUseSignalR;
    await this.setState({ isLoading: true });
    this.saveToStorage(
      {        
        UserName: this.userObj.idTokenClaims.email,
        // UserName: this.userObj,
        DefaultGridRows: this.state.numberOfGridRow,
        DefaultTimeRange: this.state.defaultSearchTimeSpan,
        DefaultUseSignalR: this.state.defaultUseSignalR,
      },
    );
    const signalRConnector = new SignalRConnector({ isUseSignalR: false });
    if (!this.state.defaultUseSignalR) {
      await signalRConnector.disconnectSignalR();
      signalRConnector.updateUseSignalR(false);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'none';
      }
    }
    await this.props.saveUserProfile(
      this.userObj.idTokenClaims.email,
      //this.userObj,
      this.state.numberOfGridRow,
      this.state.defaultSearchTimeSpan,
      this.state.defaultUseSignalR,
    );
    await this.props.getUserProfile(this.userObj.idTokenClaims.email);
    // await this.props.getUserProfile(this.userObj);
    await this.setState({ isLoading: false });
    await this.setState({ openUserProfile: false, onSaveUseSignalR: true });

    if (this.state.defaultUseSignalR) {
      await signalRConnector.connectToSignalR();
      signalRConnector.updateUseSignalR(true);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'block';
      }
    }
  };

  updateUseSignalR = async () => {
    await this.setState({ onSaveUseSignalR: false });
  }

  onClose = async () => {
    writeAIEvent(`Closed User profile modal window.`);
    await this.setState({ openUserProfile: false });
  };

  getDefaultRoute(pathName: string) {
    let defaultPath: string;
    switch (pathName) {
      case '/': {
        defaultPath = '/Home';
        break;
      }
      default: {
        defaultPath = pathName;
        break;
      }
    }
    return defaultPath;
  }

  render() {
    // {
    //     let result = "useIDP" in config;
    //     if(result && config.useIDP) {
    //       this.config = config.idp;
    //     } else {
    //       this.config = config.b2c;
    //     }
    // }
    return (
      <Suspense fallback={<div />}>
        <VirtusTheme>
          <AuthenticationHandlerAdmin
            config={config.aad}
            render={({ isAuthenticated, login, logout, user, isValidUser, error }: AuthenticationHandlerRenderProps) => {
              if (error) {
                logoutUser();
                return <></>;
              }
              if (!isValidUser.IsValidUser) {
                logoutUser();
                return <></>;
              }

              this.userObj = user;

              {/* <AuthenticationHandlerAdmin
            config={this.config}
            render={({ isAuthenticated, login, logout, user, emailAddress }: AuthenticationHandlerRenderProps) => {
              this.userObj = emailAddress; */}
              if (
                !isAuthenticated &&
                this.props.authStatus.status === 'initialized' &&
                this.props.authError === undefined
              ) {
                // Show Unauthorzed user message
                return (
                  <WidgetContainer
                    title="Unauthorized user"
                    onRemove={widgetRemove}
                    subtitle={config.unauthorizedTextMessage}
                  />
                );
              } else {
                return (
                  <AppWrapper>
                    <Location>
                      {location => (
                        <>
                          <Header
                            {...headerConfiguration}
                            isLoggedIn={isAuthenticated}
                            onRouteChange={this.onRouteChange}
                            onLogin={login}
                            path={this.getDefaultRoute(location.location.pathname)}
                            topRightButtonText={user ? user.name : ''}
                            topRightMenuItems={[
                              ...[
                                {
                                  text: 'Use SignalR',
                                  onClick: () => console.log('Use SignalR'),
                                  component: (
                                    <UseSignalR
                                      switched={useSignalR}
                                      position="menu"
                                      onSaveUseSignalR={this.state.onSaveUseSignalR}
                                      updateUseSignalR={this.updateUseSignalR}
                                    />
                                  ),
                                  isIdleOnClick: true,
                                },
                                {
                                  text: 'Profile',
                                  onClick: this.openUserProfilePopup.bind(this),
                                },
                              ],
                              ...headerConfiguration.topRightMenuItems,
                              ...[
                                {
                                  text: 'Logout',
                                  onClick: this.logoutFromApp && logout,
                                },
                              ],
                            ]}
                            misc={
                              <UseSignalR
                                switched={false}
                                position="app"
                                isOpenSignalRDetail={this.state.isOpenSignalRDetail}
                              />
                            }
                          />
                        </>
                      )}
                    </Location>
                    {isAuthenticated && (
                      <RouterStyled>
                        <Home path="/" />
                        <Home path="/Home" />
                        <Logs path="/Logs" />
                        <ErrorLog path="/Logs/ErrorLog" />
                        <EventLog path="/Logs/EventLog" />
                        <SignalRLog path="/Logs/SignalRLog" />
                        <UserLog path="/Logs/UserLog" />
                        <UserLogPage path="/Logs/UserLogPage" />
                        <Tools path="/Tools" />
                        <AddError path="/Tools/AddError" />
                        <Application path="/Tools/Application" />
                        <DevOpsOutput path="/Tools/DevOpsOutput" />
                        <ApplicationInsight path="/AppInsightDetails" />
                        <NotFound default />
                      </RouterStyled>
                    )}
                    {isAuthenticated && (
                      <>
                        <AdminUserProfile>
                          {({ isLoading, userProfile }: AdminUserProfileProps) => {
                            return isLoading ? (
                              <Loading
                                type={LoadingIconType.Virtus}
                                size={LoadingIconSizes.large}
                                show={isLoading}
                                text="Acquiring User Profile information. Please wait..."
                                full
                              />
                            ) : (
                              <>
                                {isAuthenticated && (
                                  this.saveToStorage(userProfile)
                                )}
                              </>)
                          }}
                        </AdminUserProfile>
                      </>)}
                    <DetailsLogInspector />

                    <EditModal
                      isLoading={false}
                      isModalOpen={this.state.openUserProfile}
                      modalHeader={'User Profile'}
                      onCloseModal={this.onClose.bind(this)}
                      onSave={this.saveUserProfile.bind(this)}
                    >
                      <Loading
                        loading={this.state.isLoading}
                        type="light"
                        style={{ position: 'absolute', left: '50%' }}
                      />

                      <table>
                        <tbody>
                          <DropDownControlCodeTableRow
                            label="Number of Grid Rows"
                            name="numberOfGridRow"
                            value={this.state.numberOfGridRow}
                            valueField="numberOfGridRow"
                            displayField="numberOfGridRow"
                            data={this.state.numberOfGridRows}
                            selectOption="(None)"
                            isRequired={true}
                            isReadonly={false}
                            onChange={this.changeHandler.bind(this)}
                          />
                          <DropDownControlCodeTableRow
                            label="Default Search Time Span"
                            name="defaultSearchTimeSpan"
                            value={this.state.defaultSearchTimeSpan}
                            valueField="defaultSearchTimeSpanValue"
                            displayField="defaultSearchTimeSpan"
                            data={this.state.defaultSearchTimeSpans}
                            selectOption="(None)"
                            isRequired={true}
                            isReadonly={false}
                            onChange={this.changeHandler.bind(this)}
                          />
                          <CheckBoxControlRow label="Use SignalR by default"
                            isRequired={false}
                            isReadonly={false}
                            value={Boolean(this.state.defaultUseSignalR)}
                            name="defaultUseSignalR"
                            onChange={this.changeCheck.bind(this)} />
                        </tbody>
                      </table>
                    </EditModal>
                  </AppWrapper>
                );
              }
            }}
          />
        </VirtusTheme>
      </Suspense>
    );
  }
  private async changeHandler(event: any) {
    await this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
    });
  }

  private async changeCheck(event: any) {
    await this.setState({
      ...this.state,
      defaultUseSignalR: event.target.checked,
    });
  }
}

const widgetRemove = () => {
  return;
};

const mapStateToProps = (state: RootState): ReduxProps => {
  const { userName, numberOfGridRow, defaultSearchTimeSpan, defaultUseSignalR } = App.getDetails();
  return {
    authStatus: authSelectors.getStatus(state),
    authError: authSelectors.loginError(state),
    //  id_token: authSelectors.getAccessToken(state),
    response: appResponseSelector(state),
    isLoading: querySelectors.isPending(
      state.queries,
      saveUserProfile(userName, numberOfGridRow, defaultSearchTimeSpan, defaultUseSignalR),
    ),
  };
};

const mapDispatchToProps: ReduxDispatch = {
  closeInspectors: inspectorActions.close,
  clearDateRanges: dateRangeSelectorActions.clearDateRange,
  closeTimeFrame: dateRangeSelectorActions.closeTimeFrame,
  saveUserProfile: (userName: string, numberofGridRow: string, defaultSearchTimeSpan: string, defaultUseSignalR: boolean) =>
    mutateAsync(saveUserProfile(userName, numberofGridRow, defaultSearchTimeSpan, defaultUseSignalR)),
  getUserProfile: (userName: string) => mutateAsync(getUserProfile(userName)),
};

export default hot(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const RouterStyled = styled(Router)`
  flex: 1;
  display: flex;
  flex-grow: 1;
`;


